// extracted by mini-css-extract-plugin
export default {"contador":"countdownTimer_contador__b+u11","gg":"countdownTimer_gg__aGDdh","kk":"countdownTimer_kk__RVMBc"};